<template>
  <div class="c-footer" :class="horizontal ? 'horizontal' : 'vertical' ">
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-footer',
    props: {
      horizontal: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?b2cbf948